export default __webpack_public_path__ + "static/media/Call-white.06c542e3.svg";